export default __webpack_public_path__ + "static/media/samsungFrontBack.b6b32775.png";